import React from 'react';
import { Button, styled } from '@mui/material';

const StyledActionButton = styled(Button)(({ theme }) => {
  return {
    width: 92,
    height: 50,
    color: theme.custom.buttonTextColorVariantOne,
    fontSize: 16,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: 0.1,
    cursor: 'pointer',
    borderRadius: 6,
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.custom.buttonTextColorVariantOne,
    },
    textTransform: 'none',
  };
});

const ActionButton = ({ label, onClick, customStyles = {}, actionLoading = false, btnDisabled = false }) => (
  <StyledActionButton disabled={actionLoading || btnDisabled} sx={customStyles} onClick={onClick}>
    {label}
  </StyledActionButton>
);

export default ActionButton;
